// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay-info-question-cta.question-mark-cta[data-v-15fe52f0]{top:28px;right:2px}.overlay-info-question-cta[data-v-15fe52f0] .question-mark-cta__inner{box-shadow:0 0 5px 10px #fff}.overlay-info-question-cta--checkbox.question-mark-cta[data-v-15fe52f0]{position:static;top:auto;right:auto;padding-top:0;padding-right:12px;padding-bottom:0;transform:translateY(0)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
